/**
 * This module exports functions that generate random data for testing and implementation usage
 */

/**
 * Returns a random string of length 6
 */
export const generateRandomHash = (): string => Math.random().toString(36).substring(2, 8);
